import { Actions } from '../../interfaces'

import find from './find'
import { AgreementProduct } from '@/entities/settings'

export const actions: Actions = {
  find,
}

export default {
  Model: { AgreementProduct },
  actions: { [AgreementProduct.name]: actions },
}
